import React from "react";

export default function ProfileCards({ children, imgSrc, props, headerText }) {
  return (
    <div>
      <div
        {...props}
        className="relative max-w-sm overflow-hidden rounded-2xl shadow-lg group my-4"
      >
        <div class="relative h-[100vh] sm:h-[75vh] md:h-[40vh] w-full overflow-hidden">
          <img
            src={imgSrc}
            className="w-full h-full object-cover object-center transition-transform duration-200 group-hover:scale-125"
          />
        </div>
        <div className="absolute inset-0 flex items-end bg-gradient-to-t from-black/55 to-transparent">
          <div className="text-white p-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            {children}
          </div>
        </div>
      </div>
      <div className="Uppercase md:text-2xl text-lg sm:text-xl font-bold items-start text-center text-[#01184D]">
        <h1>{headerText}</h1>
      </div>
    </div>
  );
}
